export default __webpack_public_path__ + "static/media/PlentifulPairs.63681343.png";